// Intersection Observerを使用してカートボタンの表示状態を監視
const cartButton = document.getElementById('cart-button');
const floatingCart = document.getElementById('floatingCartContainer');
import { productSliderLarge, productMainImageSlider, productMainImageModalSlider, productMainImageModalThumbnailSlider } from './functions/splideSlider';

productSliderLarge();
productMainImageSlider();
productMainImageModalSlider();

// 各商品詳細ページ：価格表示部分
// -------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  const pulldownRadios = document.querySelectorAll('input[id="premium_price"], input[id="tadabon_price"]');
  if (pulldownRadios.length) {
    pulldownRadios.forEach((radio) => {
      radio.addEventListener('click', () => {
        togglePulldown(radio);
      });
    });
  }

  const radios = document.querySelectorAll('input[name="price_option"]');
  radios.forEach((radio) => {
    radio.addEventListener('change', function () {
      const selectedRadio = this;
      const allRadios = document.querySelectorAll('input[name="price_option"]');

      // 選択されたラジオボタンに応じて背景色を変更
      allRadios.forEach((radio) => {
        const container = radio.closest('.js-changeColor');
        if (container) {
          container.classList.remove('selected');
          if (radio.id === 'timesale_price') {
            container.classList.remove('timesale-selected');
          }
        }
      });
      selectedRadio.classList.add('is-open');
      const container = selectedRadio.closest('.js-changeColor');
      if (container) {
        container.classList.add('selected');
        if (selectedRadio.id === 'timesale_price') {
          container.classList.add('timesale-selected');
        }
      }

      allRadios.forEach((radio) => {
        const targetId = radio.dataset.target;
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          // nullチェックを行う
          if (radio === selectedRadio) {
            targetElement.style.height = targetElement.scrollHeight + 'px'; // アニメーションのために高さを自動計算
            targetElement.style.transition = 'height 0.5s ease-in-out 0.1s cubic-bezier(0.85, 0, 0.15, 1)'; // アニメーションを設定
            radio.checked = true; // ラジオボタンを選択状態にする
          } else {
            targetElement.style.height = '0'; // プルダウンを非表示にする
            radio.checked = false; // ラジオボタンの選択を解除する
          }
        }
      });

      // premium_priceが選択された場合（テキスト切り替え）
      const textChange1 = document.getElementById('js-textChange1');
      const textReturn1 = document.getElementById('js-textReturn1');

      if (textChange1 && textReturn1) {
        if (selectedRadio.id === 'premium_price') {
          textChange1.style.visibility = 'visible';
          textReturn1.style.visibility = 'hidden';
        }
      }

      // tadabon_priceが選択された場合（テキスト切り替え）
      const textChange2 = document.getElementById('js-textChange2');
      const textReturn2 = document.getElementById('js-textReturn2');

      if (textChange2 && textReturn2) {
        if (selectedRadio.id === 'tadabon_price') {
          textChange2.style.visibility = 'visible';
          textReturn2.style.visibility = 'hidden';
        }
      }

      console.log('onChange');
    });
  });

  // カートに入れるボタン押下時
  const allAddCartButtons = document.querySelectorAll('.addCart');
  if (allAddCartButtons) {
    allAddCartButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        // data-titleが存在する場合、モーダルのテキストに設定
        if (button.dataset.title) {
          document.querySelector('.c-modal__cart-name').innerHTML = button.dataset.title;
        }
      });
    });
  }

  // タイムセール価格が存在する場合には、ロード時選択状態にする
  const initialRadio = document.getElementById('timesale_price');
  if (initialRadio) {
    initialRadio.dispatchEvent(new Event('change'));
  }
});

// プルダウンがあるラジオボタン押下時
// -------------------------------------
const togglePulldown = (radio) => {
  radio.classList.toggle('is-open');
  // premium_priceが選択された場合（テキスト切り替え）
  const textChange1 = document.getElementById('js-textChange1');
  const textReturn1 = document.getElementById('js-textReturn1');

  if (textChange1 && textReturn1) {
    if (radio.classList.contains('is-open')) {
      textChange1.style.visibility = 'visible';
      textReturn1.style.visibility = 'hidden';
    } else {
      textChange1.style.visibility = 'hidden';
      textReturn1.style.visibility = 'visible';
    }
  }

  // tadabon_priceが選択された場合（テキスト切り替え）
  const textChange2 = document.getElementById('js-textChange2');
  const textReturn2 = document.getElementById('js-textReturn2');

  if (textChange2 && textReturn2) {
    if (radio.classList.contains('is-open')) {
      textChange2.style.visibility = 'visible';
      textReturn2.style.visibility = 'hidden';
    } else {
      textChange2.style.visibility = 'hidden';
      textReturn2.style.visibility = 'visible';
    }
  }
};

// ゲーム機ページ：カラー、コンディション
// 読み込み時プルダウンの動作（SP時非表示、PC時表示）
// ---------------------------------
window.addEventListener('load', () => {
  const windowWidth = window.innerWidth;
  const toggleButton1 = document.getElementById('js-pullDownTitle1');
  const toggleContent1 = document.getElementById('js-newColorContainer');
  const toggleButton2 = document.getElementById('js-pullDownTitle2');
  const toggleContent2 = document.getElementById('js-newConditionContainer');

  if (toggleContent2) {
    if (windowWidth <= 768) {
      // SP時は非表示にする
      toggleContent2.style.height = '0';
    } else {
      // PC時はトグルを表示
      toggleContent2.style.height = 'auto';
    }
  }
});

// ウィンドウのリサイズイベント
window.addEventListener('resize', () => {
  const windowWidth = window.innerWidth;
  const toggleButton1 = document.getElementById('js-pullDownTitle1');
  const toggleContent1 = document.getElementById('js-newColorContainer');
  const toggleButton2 = document.getElementById('js-pullDownTitle2');
  const toggleContent2 = document.getElementById('js-newConditionContainer');

  if (toggleContent2) {
    if (windowWidth <= 768) {
      // SP時は非表示にする
      toggleContent2.style.height = '0';
    } else {
      // PC時はトグルを表示
      toggleContent2.style.height = 'auto';
    }
  }
});

// ゲーム機ページ：カラー、コンディションのボタン内
// -------------------------------------
const productColorBtns = document.querySelectorAll('input[name="product-color"]');
const productConditionBtns = document.querySelectorAll('input[name="product-condition"]');

// カラーボタンに対するイベントリスナーを追加
productColorBtns.forEach((btn) => {
  btn.addEventListener('click', function () {
    // 親要素がdisabledであれば処理しない
    if (this.closest('.l-product__information-btn').classList.contains('disabled')) return;

    // すべてのカラーボタンから"selected"クラスを削除
    productColorBtns.forEach((btn) => {
      btn.parentElement.classList.remove('selected');
    });
    // クリックされたボタンの親要素に"selected"クラスを追加
    this.parentElement.classList.add('selected');
    // 選択されたカラーを表示する要素に選択されたカラーを反映
    document.getElementById('selectedColorDisplay').textContent = this.value;
  });
});

// コンディションボタンに対するイベントリスナーを追加
productConditionBtns.forEach((btn) => {
  btn.addEventListener('click', function () {
    // 親要素がdisabledであれば処理しない
    if (this.closest('.l-product__information-btn').classList.contains('disabled')) return;

    // すべてのコンディションボタンから"selected"クラスを削除
    productConditionBtns.forEach((btn) => {
      btn.parentElement.classList.remove('selected');
    });
    // クリックされたボタンの親要素に"selected"クラスを追加
    this.parentElement.classList.add('selected');
    // 選択されたコンディションを表示する要素に選択されたコンディションを反映
    document.getElementById('selectedConditionDisplay').textContent = this.value;
  });
});

// 本、コミックページ：セット商品があった場合
// -------------------------------------
// この商品のセット内容を表示させる
document.addEventListener('DOMContentLoaded', function () {
  var button = document.getElementById('js-showList');
  if (button) {
    // ボタンが存在する場合のみイベントリスナーを設定する
    button.addEventListener('click', function () {
      var list = document.querySelector('.js-showList');
      if (list) {
        // 対象の要素が存在する場合のみ処理を実行する
        if (list.style.display === 'none' || list.style.display === '') {
          list.style.display = 'block';
        } else {
          list.style.display = 'none';
        }
      }
    });
  }
});

// 各商品詳細ページ：カートボタンが画面から外れたらカート要素を表示
// -------------------------------------
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      // カートボタンが画面外にスクロールされたらカート要素を表示
      floatingCart.style.right = '0px'; // 右からスライドしてくる位置
    } else {
      // カートボタンが画面内にある場合はカート要素を非表示にする
      floatingCart.style.right = '-250px'; // 右にスライドアウト
    }
  });
});

observer.observe(cartButton);

// CD、DVDページ：商品詳細（曲リスト）のプルダウン
// SPとPCで読み込み時に取得する高さを変更
// ---------------------------------
const pullDownCommonElements = document.querySelectorAll('.l-product__track-more');

const spHeight = '140';
const pcHeight = '180';

pullDownCommonElements.forEach((element) => {
  if (window.innerWidth <= 768) {
    element.setAttribute('data-height', spHeight);
  } else {
    element.setAttribute('data-height', pcHeight);
  }
});

// SP時のみ表示する固定カートボタン
// ---------------------------------
const targetCart = document.getElementById('js-cartTarget');
const stickyCart = document.getElementById('js-cartSticky');

const createObserver = () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyCart.classList.remove('is-show');
        } else {
          stickyCart.classList.add('is-show');
        }
      });
    },
    {
      root: null,
      threshold: 0,
    },
  );

  observer.observe(targetCart);
};

const mediaQuery = window.matchMedia('(min-width: 768px)');

const handleMediaQuery = (mediaQuery) => {
  if (!mediaQuery.matches) {
    createObserver();
  }
};

document.addEventListener('DOMContentLoaded', function () {
  if (targetCart && stickyCart) {
    handleMediaQuery(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaQuery);
  }
});

// 初期ロード時に選択されたカラーまでスクロールする（ゲームコンソール時のみ実行）
// ---------------------------------
const colorContainer = document.getElementById('selectedColorDisplay');
const colorBox = document.getElementById('js-colorBox');
const onScrollBox = () => {
  const selectedColor = colorContainer.textContent;
  const selectedLabel = document.querySelector('input[name="product-color"][value="' + selectedColor + '"]');

  if (selectedLabel) {
    const offsetLeft = selectedLabel.offsetLeft - 90;
    colorBox.scrollTo({
      left: offsetLeft,
      behavior: 'instant',
    });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  if (colorContainer && colorBox) {
    onScrollBox();
  }
});
